export default "__VITE_ASSET__CUHR9z3n__"